define('lib/Podio.Colors',[],function () {

  /*
   ******************************************************************
   Color palette
   ******************************************************************
   */

  return {
    type: {
      regular: '#444',
      mediumOnGrey: '#666',
      medium: '#999',
      linkLight: '#ccc',
      linkBlue: '#4A87B6',
      blue: '#ACCDE0',
      red: '#d74750',
      headerLightBlue: '#A3C2D8'
    },
    block: {
      grey: '#e9e9e9',
      lightGrey: '#f6f6f6',
      veryLightGrey: '#fafafa',
      darkGrey: '#D9D9D9',
      veryDarkGrey: '#666',
      white: '#fff',
      blue: '#5092BD',
      yellow: '#fffee0',
      lightYellow: '#ffffcc',
      mediumYellow: '#f6ef95',
      boldYellow: '#f5c823',
      green: '#46A847',
      lightGreen: '#ddf1cc',
      lightBlue: '#d2e4ec',
      lightRed: '#f9f2f2',
      lightRed2: '#fdf6f6',
      teal900: '#003d48',
      teal900Opaque: 'rgba(0, 61, 72, 0.1)'
    },
    border: {
      grey: '#e9e9e9',
      darkGrey: '#ccc',
      lightOnDark: '#dddddd',
      lightGreen: '#b5de96',
      lightBlue: '#ACCDE0',
      lightRed: '#f6e2e3',
      darkGreen: '#CAE0C3',
      darkYellow: '#e2e3c8',
      darkBlue: '#4A87B6',
      overdueTaskRed: '#f3b4b4'
    },
    button: {
      lightGrey: {
        background: '#f6f6f6',
        foreground: '#444'
      },
      darkGrey: {
        background: '#ddd',
        foreground: '#444'
      },
      green: {
        background: '#5bc85b',
        foreground: '#fff',
        hover: {
          background: '#82d482',
          foreground: '#fff'
        }
      },
      darkGreen: {
        background: '#6B9E41',
        foreground: '#fff'
      },
      teal: {
        background: '#05758a',
        foreground: '#fff',
        hover: {
          background: '#005463',
          foreground: '#fff'
        }
      },
      purple100: '#691cc2',
      lightGreen: '#dcebd8',
      blue: '#5092bd',
      lightBlue: '#75a9cb',
      red: '#d94850'
    },
    shadow: '#323232',
    defaults: ['DDDDDD', 'F7D1D0', 'DCEBD8', 'D2E4EB', 'F7F0C5', 'E1D8ED', 'FFD5C2', 'D1F3EC','E1D8EE'],
    defaultCompliments: {
      'DDDDDD': '6D6D6D',
      'F7D1D0': 'C52622',
      'DCEBD8': '5C964D',
      'D2E4EB': '448199',
      'F7F0C5': 'C1AA1B',
      'E1D8ED': '6C489C',
      'FFD5C2': 'E14600', // Seems the most common color...
      'D1F3EC': '2FB599',
      'E1D8EE': '957CB8', // Added a Purple for some variety.
    },
    categoryColors: ['F3F3F3', 'FFD1D1', 'CFFCC7', 'B5E3FF', 'FAF2C4', 'E3D6FF', 'FFD5B8', 'BDF0ED',
                     'C8C8C8', 'FF7373', '8FDE6B', '7DC7FF', 'FFD652', 'CCADFF', 'FF8B38','36C2CC'],
    defaultCategoryColor: 'CFFCC7',
    // http://stackoverflow.com/questions/17175664/get-the-closest-color-name-depending-on-an-hex-color
    colorDistance: function(s, t) {
      var self = this;
      if (!s.length || !t.length) {
        return 0;
      }
      return self.colorDistance(s.slice(2), t.slice(2)) + Math.abs(parseInt(s.slice(0, 2), 16) - parseInt(t.slice(0, 2), 16));
    },
    getClosestColor: function(arr, str) {
      var self = this;
      return arr.sort(function (a, b) {
        return self.colorDistance(a, str) - self.colorDistance(b, str);
      })[0];
    },
    getColorFromString: function(str) {
      var hash = 0, hexBuilder = '', color = '333333';
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      hexBuilder = (hash & 0x00FFFFFF).toString(16).toUpperCase();
      color = color.substring(0, 6 - hexBuilder.length) + hexBuilder;
      return color;
    }
  }
});

